module.exports = __webpack_public_path__ + "img/plus.25dae21a.svg";